import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'ActionPanelUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ActionPanelUI/ActionPanelUI.vue'),
    },
    {
      name: 'ApplicationContextUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ApplicationContextUI/ApplicationContextUI.vue'),
    },
    {
      name: 'AvatarUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AvatarUI/AvatarUI.vue'),
    },
    {
      name: 'BooleanFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/BooleanFormFieldUI/BooleanFormFieldUI.vue'),
    },
    {
      name: 'Bug28166UI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/Bug28166UI/Bug28166UI.vue'),
    },
    {
      name: 'ButtonUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ButtonUI/ButtonUI.vue'),
    },
    {
      name: 'ButtonWithContentAlignUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ButtonWithContentAlignUI/ButtonWithContentAlignUI.vue'),
    },
    {
      name: 'CancelPositionChangingDatagridUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CancelPositionChangingDatagridUI/CancelPositionChangingDatagridUI.vue'),
    },
    {
      name: 'CardComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CardComponentUI/CardComponentUI.vue'),
    },
    {
      name: 'CarouselUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CarouselUI/CarouselUI.vue'),
    },
    {
      name: 'CharacterCasingStringFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CharacterCasingStringFormFieldUI/CharacterCasingStringFormFieldUI.vue'),
    },
    {
      name: 'CharacterCasingStringTextboxUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CharacterCasingStringTextboxUI/CharacterCasingStringTextboxUI.vue'),
    },
    {
      name: 'ChartUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ChartUI/ChartUI.vue'),
    },
    {
      name: 'ComboboxBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxBaseUI/ComboboxBaseUI.vue'),
    },
    {
      name: 'ComboboxDefaultUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxDefaultUI/ComboboxDefaultUI.vue'),
    },
    {
      name: 'ComboboxDefaultUIEx',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxDefaultUIEx/ComboboxDefaultUIEx.vue'),
    },
    {
      name: 'ComboboxDefaultUIStates',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxDefaultUIStates/ComboboxDefaultUIStates.vue'),
    },
    {
      name: 'ComboboxEditableDefaultUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxEditableDefaultUI/ComboboxEditableDefaultUI.vue'),
    },
    {
      name: 'ComboboxHorizontalRadioUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxHorizontalRadioUI/ComboboxHorizontalRadioUI.vue'),
    },
    {
      name: 'ComboboxSelectButtonUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxSelectButtonUI/ComboboxSelectButtonUI.vue'),
    },
    {
      name: 'ComboboxVerticalRadioUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComboboxVerticalRadioUI/ComboboxVerticalRadioUI.vue'),
    },
    {
      name: 'ContextWithSourceUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ContextWithSourceUI/ContextWithSourceUI.vue'),
    },
    {
      name: 'DGDragDropUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DGDragDropUI/DGDragDropUI.vue'),
    },
    {
      name: 'DGRowDetailDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DGRowDetailDetailUI/DGRowDetailDetailUI.vue'),
    },
    {
      name: 'DGRowDetailMasterExpandedByDefaultUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DGRowDetailMasterExpandedByDefaultUI/DGRowDetailMasterExpandedByDefaultUI.vue'),
    },
    {
      name: 'DGRowDetailMasterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DGRowDetailMasterUI/DGRowDetailMasterUI.vue'),
    },
    {
      name: 'DatagridButtonsNextPrevious',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridButtonsNextPrevious/DatagridButtonsNextPrevious.vue'),
    },
    {
      name: 'DatagridButtonsNextPreviousServer',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridButtonsNextPreviousServer/DatagridButtonsNextPreviousServer.vue'),
    },
    {
      name: 'DatagridCustomColumnButton',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridCustomColumnButton/DatagridCustomColumnButton.vue'),
    },
    {
      name: 'DatagridCustomColumnEditButton',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridCustomColumnEditButton/DatagridCustomColumnEditButton.vue'),
    },
    {
      name: 'DatagridInTabsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridInTabsUI/DatagridInTabsUI.vue'),
    },
    {
      name: 'DatagridPagination',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridPagination/DatagridPagination.vue'),
    },
    {
      name: 'DatagridWithInfiniteScrolling',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridWithInfiniteScrolling/DatagridWithInfiniteScrolling.vue'),
    },
    {
      name: 'DatagridWithSwitchUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridWithSwitchUI/DatagridWithSwitchUI.vue'),
    },
    {
      name: 'DatagridWithToolbarInHorizontalScroll',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridWithToolbarInHorizontalScroll/DatagridWithToolbarInHorizontalScroll.vue'),
    },
    {
      name: 'DatagridWithoutSelectionColumnUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DatagridWithoutSelectionColumnUI/DatagridWithoutSelectionColumnUI.vue'),
    },
    {
      name: 'DateFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DateFormFieldUI/DateFormFieldUI.vue'),
    },
    {
      name: 'DecimalFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DecimalFormFieldUI/DecimalFormFieldUI.vue'),
    },
    {
      name: 'DefaultBooleanFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DefaultBooleanFormFieldUI/DefaultBooleanFormFieldUI.vue'),
    },
    {
      name: 'DefaultDatagridUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DefaultDatagridUI/DefaultDatagridUI.vue'),
    },
    {
      name: 'DefaultEnumFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DefaultEnumFormFieldUI/DefaultEnumFormFieldUI.vue'),
    },
    {
      name: 'DefaultStringFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DefaultStringFormFieldUI/DefaultStringFormFieldUI.vue'),
    },
    {
      name: 'DetailDatagridUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DetailDatagridUI/DetailDatagridUI.vue'),
    },
    {
      name: 'DetailEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DetailEntityUI/DetailEntityUI.vue'),
    },
    {
      name: 'DetailEntityWithReferenceUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DetailEntityWithReferenceUI/DetailEntityWithReferenceUI.vue'),
    },
    {
      name: 'DirectiveLayoutAlignSelfUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DirectiveLayoutAlignSelfUI/DirectiveLayoutAlignSelfUI.vue'),
    },
    {
      name: 'DirectiveLayoutHeightAndWidthUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DirectiveLayoutHeightAndWidthUI/DirectiveLayoutHeightAndWidthUI.vue'),
    },
    {
      name: 'DirectiveStyleCornerRadiusUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DirectiveStyleCornerRadiusUI/DirectiveStyleCornerRadiusUI.vue'),
    },
    {
      name: 'DividerComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DividerComponentUI/DividerComponentUI.vue'),
    },
    {
      name: 'DividerWithContentAlignUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DividerWithContentAlignUI/DividerWithContentAlignUI.vue'),
    },
    {
      name: 'DocumentationButtonUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DocumentationButtonUI/DocumentationButtonUI.vue'),
    },
    {
      name: 'ExhaustiveLookupFormFieldReferenceUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ExhaustiveLookupFormFieldReferenceUI/ExhaustiveLookupFormFieldReferenceUI.vue'),
    },
    {
      name: 'ExhaustiveLookupFormFieldScalarPropertyChooseOnlyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ExhaustiveLookupFormFieldScalarPropertyChooseOnlyUI/ExhaustiveLookupFormFieldScalarPropertyChooseOnlyUI.vue'),
    },
    {
      name: 'ExhaustiveLookupFormFieldScalarPropertyWithAllowFreeValueUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ExhaustiveLookupFormFieldScalarPropertyWithAllowFreeValueUI/ExhaustiveLookupFormFieldScalarPropertyWithAllowFreeValueUI.vue'),
    },
    {
      name: 'ExhaustiveLookupUnboundUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ExhaustiveLookupUnboundUI/ExhaustiveLookupUnboundUI.vue'),
    },
    {
      name: 'ExpressionEditorUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ExpressionEditorUI/ExpressionEditorUI.vue'),
    },
    {
      name: 'FileFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FileFormFieldUI/FileFormFieldUI.vue'),
    },
    {
      name: 'FileUploadUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FileUploadUI/FileUploadUI.vue'),
    },
    {
      name: 'FilterBarChipUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FilterBarChipUI/FilterBarChipUI.vue'),
    },
    {
      name: 'FilterBarUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FilterBarUI/FilterBarUI.vue'),
    },
    {
      name: 'FilterBarWithRequiredFilterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FilterBarWithRequiredFilterUI/FilterBarWithRequiredFilterUI.vue'),
    },
    {
      name: 'FormFieldFocusUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FormFieldFocusUI/FormFieldFocusUI.vue'),
    },
    {
      name: 'FormFieldInRepeatUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FormFieldInRepeatUI/FormFieldInRepeatUI.vue'),
    },
    {
      name: 'FormFieldValidationMessageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FormFieldValidationMessageUI/FormFieldValidationMessageUI.vue'),
    },
    {
      name: 'GlobalSearchButtonUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/GlobalSearchButtonUI/GlobalSearchButtonUI.vue'),
    },
    {
      name: 'GlobalSearchInputUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/GlobalSearchInputUI/GlobalSearchInputUI.vue'),
    },
    {
      name: 'GridLayoutComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/GridLayoutComponentUI/GridLayoutComponentUI.vue'),
    },
    {
      name: 'GroupBoxComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/GroupBoxComponentUI/GroupBoxComponentUI.vue'),
    },
    {
      name: 'GuidKeyEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/GuidKeyEntityUI/GuidKeyEntityUI.vue'),
    },
    {
      name: 'HeadingComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HeadingComponentUI/HeadingComponentUI.vue'),
    },
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'HorizontalLayoutComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HorizontalLayoutComponentUI/HorizontalLayoutComponentUI.vue'),
    },
    {
      name: 'HorizontalScroll',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HorizontalScroll/HorizontalScroll.vue'),
    },
    {
      name: 'HtmlViewerExampleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HtmlViewerExampleUI/HtmlViewerExampleUI.vue'),
    },
    {
      name: 'ImageFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ImageFormFieldUI/ImageFormFieldUI.vue'),
    },
    {
      name: 'InputDirectiveStyleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InputDirectiveStyleUI/InputDirectiveStyleUI.vue'),
    },
    {
      name: 'InputFileUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InputFileUI/InputFileUI.vue'),
    },
    {
      name: 'InputImageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InputImageUI/InputImageUI.vue'),
    },
    {
      name: 'IntegerKeyEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/IntegerKeyEntityUI/IntegerKeyEntityUI.vue'),
    },
    {
      name: 'LabelPositionFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LabelPositionFormFieldUI/LabelPositionFormFieldUI.vue'),
    },
    {
      name: 'LayoutWithMultilineTextboxes',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LayoutWithMultilineTextboxes/LayoutWithMultilineTextboxes.vue'),
    },
    {
      name: 'LoadDataOnScrollUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LoadDataOnScrollUI/LoadDataOnScrollUI.vue'),
    },
    {
      name: 'LocalizableStringFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LocalizableStringFormFieldUI/LocalizableStringFormFieldUI.vue'),
    },
    {
      name: 'LookupCreationUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupCreationUI/LookupCreationUI.vue'),
    },
    {
      name: 'LookupEditingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupEditingUI/LookupEditingUI.vue'),
    },
    {
      name: 'LookupFormFieldReferenceCustomModalUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupFormFieldReferenceCustomModalUI/LookupFormFieldReferenceCustomModalUI.vue'),
    },
    {
      name: 'LookupFormFieldReferenceDifferentEntityViewsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupFormFieldReferenceDifferentEntityViewsUI/LookupFormFieldReferenceDifferentEntityViewsUI.vue'),
    },
    {
      name: 'LookupFormFieldReferenceUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupFormFieldReferenceUI/LookupFormFieldReferenceUI.vue'),
    },
    {
      name: 'LookupFormFieldScalarPropertyFreeValueUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupFormFieldScalarPropertyFreeValueUI/LookupFormFieldScalarPropertyFreeValueUI.vue'),
    },
    {
      name: 'LookupFormFieldScalarPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupFormFieldScalarPropertyUI/LookupFormFieldScalarPropertyUI.vue'),
    },
    {
      name: 'LookupLocalizableDisplayUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupLocalizableDisplayUI/LookupLocalizableDisplayUI.vue'),
    },
    {
      name: 'LookupMultipleSuggestionSearchUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupMultipleSuggestionSearchUI/LookupMultipleSuggestionSearchUI.vue'),
    },
    {
      name: 'LookupQuickSearchNumericUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupQuickSearchNumericUI/LookupQuickSearchNumericUI.vue'),
    },
    {
      name: 'LookupQuickSearchStringUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupQuickSearchStringUI/LookupQuickSearchStringUI.vue'),
    },
    {
      name: 'LookupQuickSearchUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupQuickSearchUI/LookupQuickSearchUI.vue'),
    },
    {
      name: 'LookupScalarPropertyMainEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupScalarPropertyMainEntityUI/LookupScalarPropertyMainEntityUI.vue'),
    },
    {
      name: 'LookupScalarPropertyWithUIViewLookupFreeValuePropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LookupScalarPropertyWithUIViewLookupFreeValuePropertyUI/LookupScalarPropertyWithUIViewLookupFreeValuePropertyUI.vue'),
    },
    {
      name: 'MarkdownViewerUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MarkdownViewerUI/MarkdownViewerUI.vue'),
    },
    {
      name: 'MaskFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MaskFormFieldUI/MaskFormFieldUI.vue'),
    },
    {
      name: 'MasterEntityLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterEntityLookupUI/MasterEntityLookupUI.vue'),
    },
    {
      name: 'MasterEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterEntityUI/MasterEntityUI.vue'),
    },
    {
      name: 'MasterEntityUIWithEditableDatagridUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterEntityUIWithEditableDatagridUI/MasterEntityUIWithEditableDatagridUI.vue'),
    },
    {
      name: 'MasterEntityWithDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterEntityWithDetailUI/MasterEntityWithDetailUI.vue'),
    },
    {
      name: 'MasterEntityWithItemCloningEventUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterEntityWithItemCloningEventUI/MasterEntityWithItemCloningEventUI.vue'),
    },
    {
      name: 'MasterLookupCreationDifferentEntityViewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterLookupCreationDifferentEntityViewUI/MasterLookupCreationDifferentEntityViewUI.vue'),
    },
    {
      name: 'MasterLookupCreationUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterLookupCreationUI/MasterLookupCreationUI.vue'),
    },
    {
      name: 'MasterLookupSearchUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MasterLookupSearchUI/MasterLookupSearchUI.vue'),
    },
    {
      name: 'MaxLengthStringFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MaxLengthStringFormFieldUI/MaxLengthStringFormFieldUI.vue'),
    },
    {
      name: 'MenuItemsBindingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MenuItemsBindingUI/MenuItemsBindingUI.vue'),
    },
    {
      name: 'MessageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MessageUI/MessageUI.vue'),
    },
    {
      name: 'MultiSelectUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MultiSelectUI/MultiSelectUI.vue'),
    },
    {
      name: 'MultilineStringFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MultilineStringFormFieldUI/MultilineStringFormFieldUI.vue'),
    },
    {
      name: 'NavigateToDetailDatagridUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NavigateToDetailDatagridUI/NavigateToDetailDatagridUI.vue'),
    },
    {
      name: 'NestedTabsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NestedTabsUI/NestedTabsUI.vue'),
    },
    {
      name: 'NullableEnumFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NullableEnumFormFieldUI/NullableEnumFormFieldUI.vue'),
    },
    {
      name: 'OverlayComponentsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/OverlayComponentsUI/OverlayComponentsUI.vue'),
    },
    {
      name: 'PasswordFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PasswordFormFieldUI/PasswordFormFieldUI.vue'),
    },
    {
      name: 'PlaceholderInputFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PlaceholderInputFormFieldUI/PlaceholderInputFormFieldUI.vue'),
    },
    {
      name: 'PlaceholderTextboxUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PlaceholderTextboxUI/PlaceholderTextboxUI.vue'),
    },
    {
      name: 'ProgressBarUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProgressBarUI/ProgressBarUI.vue'),
    },
    {
      name: 'ReadOnlyDatagridUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReadOnlyDatagridUI/ReadOnlyDatagridUI.vue'),
    },
    {
      name: 'ReadOnlyDatagridWithoutLoadOnStartUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReadOnlyDatagridWithoutLoadOnStartUI/ReadOnlyDatagridWithoutLoadOnStartUI.vue'),
    },
    {
      name: 'ReadOnlyEnumFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReadOnlyEnumFormFieldUI/ReadOnlyEnumFormFieldUI.vue'),
    },
    {
      name: 'ReadOnlyTemplateCodeEditorUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReadOnlyTemplateCodeEditorUI/ReadOnlyTemplateCodeEditorUI.vue'),
    },
    {
      name: 'RepeatDatasourceUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RepeatDatasourceUI/RepeatDatasourceUI.vue'),
    },
    {
      name: 'RepeatWithHorizontalScrollUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RepeatWithHorizontalScrollUI/RepeatWithHorizontalScrollUI.vue'),
    },
    {
      name: 'RepeatWithVerticalScrollUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RepeatWithVerticalScrollUI/RepeatWithVerticalScrollUI.vue'),
    },
    {
      name: 'RichTextFormFieldUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/RichTextFormFieldUI/RichTextFormFieldUI.vue'),
    },
    {
      name: 'ShortcutLocalizableStringUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ShortcutLocalizableStringUI/ShortcutLocalizableStringUI.vue'),
    },
    {
      name: 'ShowMessageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ShowMessageUI/ShowMessageUI.vue'),
    },
    {
      name: 'ShowToastUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ShowToastUI/ShowToastUI.vue'),
    },
    {
      name: 'SliderDiscreteUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SliderDiscreteUI/SliderDiscreteUI.vue'),
    },
    {
      name: 'SpinnerUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SpinnerUI/SpinnerUI.vue'),
    },
    {
      name: 'SplitterWithMainAndDetailPanelsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SplitterWithMainAndDetailPanelsUI/SplitterWithMainAndDetailPanelsUI.vue'),
    },
    {
      name: 'TabsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TabsUI/TabsUI.vue'),
    },
    {
      name: 'TemplateCodeEditorUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TemplateCodeEditorUI/TemplateCodeEditorUI.vue'),
    },
    {
      name: 'TextComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TextComponentUI/TextComponentUI.vue'),
    },
    {
      name: 'TimelineUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TimelineUI/TimelineUI.vue'),
    },
    {
      name: 'ToolbarsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ToolbarsUI/ToolbarsUI.vue'),
    },
    {
      name: 'UIComponentInColumnTemplate',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UIComponentInColumnTemplate/UIComponentInColumnTemplate.vue'),
    },
    {
      name: 'UIComponentWithComputedUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UIComponentWithComputedUI/UIComponentWithComputedUI.vue'),
    },
    {
      name: 'UIComponentWithContentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UIComponentWithContentUI/UIComponentWithContentUI.vue'),
    },
    {
      name: 'UIComponentWithEventRulesUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UIComponentWithEventRulesUI/UIComponentWithEventRulesUI.vue'),
    },
    {
      name: 'UIComponentWithFallbackContentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UIComponentWithFallbackContentUI/UIComponentWithFallbackContentUI.vue'),
    },
    {
      name: 'UIComponentWithParametersUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UIComponentWithParametersUI/UIComponentWithParametersUI.vue'),
    },
    {
      name: 'UnboundLookupSuggestionPropertiesUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnboundLookupSuggestionPropertiesUI/UnboundLookupSuggestionPropertiesUI.vue'),
    },
    {
      name: 'UnboundLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnboundLookupUI/UnboundLookupUI.vue'),
    },
    {
      name: 'UserButtonUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserButtonUI/UserButtonUI.vue'),
    },
    {
      name: 'VerticalLayoutComponentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VerticalLayoutComponentUI/VerticalLayoutComponentUI.vue'),
    },
    {
      name: 'WebViewExternal',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/WebViewExternal/WebViewExternal.vue'),
    },
  ],
}
